export function reverseGradient(gradient) {
  const parts = gradient.match(/linear-gradient\((\d+deg),\s*(.+)\)/);
  if (!parts) {
    throw new Error('Invalid gradient format');
  }

  // Extract the direction (degree) and color stops
  const degree = parseInt(parts[1], 10);
  const colorStops = parts[2];

  // Reverse the degree by adding 180 degrees (and ensuring it's within 0-360 range)
  const reversedDegree = (degree + 180) % 360;

  // Return the new gradient with the reversed degree
  return `linear-gradient(${reversedDegree}deg, ${colorStops})`;
}

export function darkenColor(hex, percent) {
  if (hex) {
    const num = parseInt(hex.slice(1), 16),
          amt = Math.round(2.55 * percent),
          R = (num >> 16) - amt,
          G = (num >> 8 & 0x00FF) - amt,
          B = (num & 0x0000FF) - amt;
    
    return `#${(
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)}`;
  }
  return '';
}

export function lightenColor(hex, percent) {
  const num = parseInt(hex.slice(1), 16),
        amt = Math.round(2.55 * percent),
        R = (num >> 16) + amt,
        G = (num >> 8 & 0x00FF) + amt,
        B = (num & 0x0000FF) + amt;

  return `#${(
    0x1000000 +
    (R > 255 ? 255 : R) * 0x10000 +
    (G > 255 ? 255 : G) * 0x100 +
    (B > 255 ? 255 : B)
  )
    .toString(16)
    .slice(1)}`;
}

export function hexToRgba(hex, alpha = 1) {
  // Remove the hash at the start if it's there
  hex = hex.replace(/^#/, '');

  // Parse the r, g, b values from the hex string
  let r, g, b;

  if (hex.length === 3) {
    // Expand shorthand hex notation (e.g. "03F" => "0033FF")
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6) {
    r = parseInt(hex.slice(0, 2), 16);
    g = parseInt(hex.slice(2, 4), 16);
    b = parseInt(hex.slice(4, 6), 16);
  } else {
    throw new Error('Invalid hex color format');
  }

  // Return the rgba string
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export const FormatStyles = [
    {
    label: 'Sunset Vibes',
    background: 'linear-gradient(350deg, rgba(255,143,107,1) 0%, rgba(255,94,98,1) 20%, rgba(225,78,202,1) 40%, rgba(133,50,208,1) 60%, rgba(70,30,192,1) 80%, rgba(30,0,158,1) 100%)',
    timerFullBackground: '#ff5e62', 
    timerEmptyBackground: '#8732d0', 
    categoryText: '#ffffff', 
    segmentBackground: '#4634c8', 
    segmentColor: '#ffd2d3',
    clueColor: '#ffd2d3',
    clueBackground: '#4634c8',
    answerColor: '#ffffff',
    answerBackground: '#ff5e62',
  },
  {
    label: 'Ocean Breeze',
    background: 'linear-gradient(350deg, rgba(0,255,229,1) 0%, rgba(0,196,219,1) 25%, rgba(0,143,189,1) 50%, rgba(0,84,154,1) 75%, rgba(0,28,117,1) 100%)',
    timerFullBackground: '#00c4db', 
    timerEmptyBackground: '#00729e', 
    categoryText: '#ffffff', 
    segmentBackground: '#001c6e', 
    segmentColor: '#d7f9fc',
    clueColor: '#d7f9fc',
    clueBackground: '#001c6e',
    answerColor: '#ffffff',
    answerBackground: '#00c4db',
  },
  {
    label: 'Lush Greenery',
    background: 'linear-gradient(350deg, rgba(174,255,142,1) 0%, rgba(126,235,82,1) 25%, rgba(62,182,55,1) 50%, rgba(37,121,37,1) 75%, rgba(10,77,27,1) 100%)',
    timerFullBackground: '#7eeb52', 
    timerEmptyBackground: '#3eaf37', 
    categoryText: '#ffffff', 
    segmentBackground: '#0d5120', 
    segmentColor: '#d1f5d1',
    clueColor: '#d1f5d1',
    clueBackground: '#0d5120',
    answerColor: '#ffffff',
    answerBackground: '#7eeb52',
  },
  {
    label: 'Tropical Beach',
    background: 'linear-gradient(350deg, rgba(255,224,102,1) 0%, rgba(255,191,102,1) 25%, rgba(255,163,121,1) 50%, rgba(255,130,121,1) 75%, rgba(255,99,97,1) 100%)',
    timerFullBackground: '#ffbe66', 
    timerEmptyBackground: '#ff8c61', 
    categoryText: '#ffffff', 
    segmentBackground: '#ff3f3d', 
    segmentColor: '#ffe5cc',
    clueColor: '#ffffff',
    clueBackground: '#ff3f3d',
    answerColor: '#ffffff',
    answerBackground: '#ebaf5e',
  },
  {
    label: 'Bold Neon',
    background: 'linear-gradient(350deg, rgba(255,0,255,1) 0%, rgba(255,0,100,1) 25%, rgba(0,219,251,1) 50%, rgba(0,255,0,1) 75%, rgba(255,255,0,1) 100%)',
    timerFullBackground: '#ff00ff', 
    timerEmptyBackground: '#00dbfb', 
    categoryText: '#000000', 
    segmentBackground: '#00ff00', 
    segmentColor: '#ffff00',
    clueColor: '#ffff00',
    clueBackground: '#00dbfb',
    answerColor: '#000000',
    answerBackground: '#ff00ff',
  },
  {
    label: 'Purple Dream',
    background: 'linear-gradient(350deg, rgba(150,100,255,1) 0%, rgba(120,80,230,1) 25%, rgba(100,60,210,1) 50%, rgba(80,40,190,1) 75%, rgba(60,20,170,1) 100%)',
    timerFullBackground: '#a064ff', 
    timerEmptyBackground: '#5a1bb8', 
    categoryText: '#ffffff', 
    segmentBackground: '#450ea3', 
    segmentColor: '#dfd0ff',
    clueColor: '#e4d9fa',
    clueBackground: '#450ea3',
    answerColor: '#ffffff',
    answerBackground: '#a064ff',
  },
  {
    label: 'Fire and Ash',
    background: 'linear-gradient(350deg, rgba(255,102,51,1) 0%, rgba(255,51,0,1) 25%, rgba(153,76,0,1) 50%, rgba(102,51,0,1) 75%, rgba(51,25,0,1) 100%)',
    timerFullBackground: '#ff6633', 
    timerEmptyBackground: '#992a00', 
    categoryText: '#ffffff', 
    segmentBackground: '#661900', 
    segmentColor: '#ffd6cc',
    clueColor: '#f7ddd7',
    clueBackground: '#661900',
    answerColor: '#ffffff',
    answerBackground: '#ff6633',
  },
  {
    label: 'Rose Garden',
    background: 'linear-gradient(350deg, rgba(255,182,193,1) 0%, rgba(255,105,180,1) 25%, rgba(255,20,147,1) 50%, rgba(219,112,147,1) 75%, rgba(139,69,133,1) 100%)',
    timerFullBackground: '#ffb6c1', 
    timerEmptyBackground: '#ff1493', 
    categoryText: '#ffffff', 
    segmentBackground: '#d74493', 
    segmentColor: '#ffe3ec',
    clueColor: '#ffe3ec',
    clueBackground: '#d74493',
    answerColor: '#ffffff',
    answerBackground: '#ffb6c1',
  },
  {
    label: 'Desert Heat',
    background: 'linear-gradient(350deg, rgba(255,235,59,1) 0%, rgba(255,193,7,1) 25%, rgba(255,152,0,1) 50%, rgba(255,87,34,1) 75%, rgba(230,81,0,1) 100%)',
    timerFullBackground: '#ffcb30', 
    timerEmptyBackground: '#f1550a', 
    categoryText: '#ffffff', 
    segmentBackground: '#e34e00', 
    segmentColor: '#ffe8b0',
    clueColor: '#faecca',
    clueBackground: '#e34e00',
    answerColor: '#000',
    answerBackground: '#ffcb30',
  },
  {
    label: 'Winter Wonderland',
    background: 'linear-gradient(350deg, rgba(255,255,255,1) 0%, rgba(224,247,250,1) 25%, rgba(178,235,242,1) 50%, rgba(128,222,234,1) 75%, rgba(77,208,225,1) 100%)',
    timerFullBackground: '#b2ebf2', 
    timerEmptyBackground: '#77d0e1', 
    categoryText: '#005761', 
    segmentBackground: '#00515a', 
    segmentColor: '#f1fdfe',
    clueColor: '#f1fdfe',
    clueBackground: '#00515a',
    answerColor: '#005761',
    answerBackground: '#b2ebf2',
  },
  {
    label: 'Berry Blast',
    background: 'linear-gradient(350deg, rgba(255,102,178,1) 0%, rgba(204,0,153,1) 25%, rgba(153,0,204,1) 50%, rgba(102,0,204,1) 75%, rgba(51,0,153,1) 100%)',
    timerFullBackground: '#ff66b2', 
    timerEmptyBackground: '#990099', 
    categoryText: '#ffffff', 
    segmentBackground: '#660066', 
    segmentColor: '#ffccff',
    clueColor: '#ffccff',
    clueBackground: '#660066',
    answerColor: '#ffffff',
    answerBackground: '#ff66b2',
  },
  {
    label: 'Lemon Lime',
    background: 'linear-gradient(350deg, rgba(204,255,0,1) 0%, rgba(153,204,0,1) 25%, rgba(102,204,0,1) 50%, rgba(51,153,0,1) 75%, rgba(0,102,0,1) 100%)',
    timerFullBackground: '#99cc00', 
    timerEmptyBackground: '#669900', 
    categoryText: '#ffffff', 
    segmentBackground: '#336600', 
    segmentColor: '#ccff99',
    clueColor: '#dfffbf',
    clueBackground: '#336600',
    answerColor: '#ffffff',
    answerBackground: '#99cc00',
  },
  {
    label: 'Crimson Tide',
    background: 'linear-gradient(350deg, rgba(255,69,0,1) 0%, rgba(255,0,0,1) 25%, rgba(204,0,0,1) 50%, rgba(153,0,0,1) 75%, rgba(102,0,0,1) 100%)',
    timerFullBackground: '#ff4500', 
    timerEmptyBackground: '#990000', 
    categoryText: '#ffffff', 
    segmentBackground: '#660000', 
    segmentColor: '#ffb3b3',
    clueColor: '#fcd2d2',
    clueBackground: '#660000',
    answerColor: '#ffffff',
    answerBackground: '#ff4500',
  },
  {
    label: 'Arctic Chill',
    background: 'linear-gradient(350deg, rgba(204,255,255,1) 0%, rgba(153,204,255,1) 25%, rgba(102,153,255,1) 50%, rgba(51,102,255,1) 75%, rgba(0,51,255,1) 100%)',
    timerFullBackground: '#66ccff', 
    timerEmptyBackground: '#0044cc', 
    categoryText: '#ffffff', 
    segmentBackground: '#003399', 
    segmentColor: '#cce6ff',
    clueColor: '#dbeeff',
    clueBackground: '#003399',
    answerColor: '#ffffff',
    answerBackground: '#66ccff',
  },
  {
    label: 'Sandstorm',
    background: 'linear-gradient(350deg, rgba(255,204,153,1) 0%, rgba(255,178,102,1) 25%, rgba(255,153,51,1) 50%, rgba(204,102,0,1) 75%, rgba(153,51,0,1) 100%)',
    timerFullBackground: '#ff9933', 
    timerEmptyBackground: '#cc6600', 
    categoryText: '#ffffff', 
    segmentBackground: '#993300', 
    segmentColor: '#ffe0cc',
    clueColor: '#ffebde',
    clueBackground: '#993300',
    answerColor: '#ffffff',
    answerBackground: '#ff9933',
  },
  {
    label: 'Sunny Day',
    background: 'linear-gradient(350deg, rgba(255,255,102,1) 0%, rgba(255,255,51,1) 25%, rgba(255,204,0,1) 50%, rgba(255,153,0,1) 75%, rgba(255,102,0,1) 100%)',
    timerFullBackground: '#ffcc00', 
    timerEmptyBackground: '#ff9900', 
    categoryText: '#ffffff', 
    segmentBackground: '#ff6600', 
    segmentColor: '#fff0b3',
    clueColor: '#fff4c7',
    clueBackground: '#ff6600',
    answerColor: '#ffffff',
    answerBackground: '#ffcc00',
  },
  {
    label: 'Royal Velvet',
    background: 'linear-gradient(350deg, rgba(102,0,204,1) 0%, rgba(153,51,255,1) 25%, rgba(204,102,255,1) 50%, rgba(255,153,255,1) 75%, rgba(255,204,255,1) 100%)',
    timerFullBackground: '#9900cc', 
    timerEmptyBackground: '#660099', 
    categoryText: '#ffffff', 
    segmentBackground: '#330066', 
    segmentColor: '#e6ccff',
    clueColor: '#efe1fc',
    clueBackground: '#330066',
    answerColor: '#ffffff',
    answerBackground: '#9900cc',
  },
  {
    label: 'Autumn Breeze',
    background: 'linear-gradient(350deg, rgba(255,153,51,1) 0%, rgba(204,102,0,1) 25%, rgba(153,51,0,1) 50%, rgba(102,51,0,1) 75%, rgba(51,25,0,1) 100%)',
    timerFullBackground: '#ff9933', 
    timerEmptyBackground: '#cc5200', 
    categoryText: '#ffffff', 
    segmentBackground: '#993300', 
    segmentColor: '#ffcc99',
    clueColor: '#ffe8d1',
    clueBackground: '#993300',
    answerColor: '#ffffff',
    answerBackground: '#ff9933',
  },
  {
    label: 'Mountain Mist',
    background: 'linear-gradient(350deg, rgba(204,255,255,1) 0%, rgba(153,255,204,1) 25%, rgba(102,204,153,1) 50%, rgba(51,153,102,1) 75%, rgba(0,102,51,1) 100%)',
    timerFullBackground: '#66ffcc', 
    timerEmptyBackground: '#339966', 
    categoryText: '#ffffff', 
    segmentBackground: '#006633', 
    segmentColor: '#ccffe6',
    clueColor: '#defcee',
    clueBackground: '#006633',
    answerColor: '#ffffff',
    answerBackground: '#4bbf98',
  }
];